import React from "react";
import cn from "classnames";
import styles from "./index.module.css";

import PlanIcon from "subscriptions/plans/PlanIcon";
import DataAmount from "subscriptions/usage/DataAmount";
import ProgressMeter from "common/ProgressMeter";
import { percent, formatMdn, formatOrdinalDate } from "helpers/formatters";
import { isMvno } from "../utils";

export const ListItem = ({
  subscription,
  carrier,
  usage,
  subRoute,
  showSuspendedLabel,
  onClick,
}) => {
  const isSuspended =
    showSuspendedLabel && subscription[`${carrier}_status`] === "suspended";
  const notMvno = !isMvno(subscription);
  const showDataReset = Boolean(subscription.renew_at);
  const handleClick = (e) => {
    // disable actions for not mvno subs
    if (notMvno) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick(subscription.id);
    } else {
      subRoute(subscription.id);
    }
  };

  return (
    <div
      className={cn({
        [styles.ListItem]: true,
        [styles.hasUsage]: usage,
        [styles.notMvno]: notMvno,
      })}
      onClick={handleClick}
    >
      <PlanIcon plan={subscription.plan} />
      {subscription.first_name} {subscription.last_name}
      <span className={styles.mdn}>
        {notMvno ? subscription.device_id : formatMdn(subscription.mdn)}
      </span>
      {showDataReset && (
        <span className={styles.dataReset}>
          Data Reset: {formatOrdinalDate(subscription.renew_at)}
        </span>
      )}
      {usage && (
        <React.Fragment>
          <DataAmount
            used={usage.mb_used}
            avail={usage.mb_avail}
            className={styles.dataAmount}
          />
          <ProgressMeter
            percent={percent(usage.mb_used, usage.mb_avail)}
            progress="#84e298"
            remaining="#e5e5e5"
            full="#ee626a"
          />
        </React.Fragment>
      )}
      {isSuspended && (
        <span className={styles.suspended}>
          Service <br /> suspended
        </span>
      )}
    </div>
  );
};

export default ListItem;
